var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 26,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m1.756 23.893 1.372-5.215a10.366 10.366 0 0 1-1.29-5.035c0-5.554 4.34-10.068 9.67-10.068 1.271 0 2.53.26 3.703.767a9.655 9.655 0 0 1 3.138 2.184c.898.936 1.61 2.047 2.096 3.27.486 1.222.736 2.532.735 3.855-.002 5.553-4.341 10.068-9.671 10.068h-.004a9.363 9.363 0 0 1-4.622-1.226l-5.127 1.4Zm5.365-3.222.294.18a7.79 7.79 0 0 0 4.09 1.168h.004c4.43 0 8.036-3.755 8.038-8.37 0-1.098-.207-2.187-.61-3.203a8.402 8.402 0 0 0-1.742-2.716 8.026 8.026 0 0 0-2.607-1.816 7.762 7.762 0 0 0-3.076-.639c-4.434 0-8.04 3.754-8.042 8.368A8.608 8.608 0 0 0 4.7 18.097l.192.316-.81 3.088 3.04-.83Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m2.093 23.542 1.325-5.037a10.009 10.009 0 0 1-1.247-4.859c0-5.36 4.19-9.72 9.337-9.72 1.226 0 2.44.252 3.573.741a9.321 9.321 0 0 1 3.03 2.109 9.76 9.76 0 0 1 2.023 3.155c.47 1.18.71 2.445.71 3.722 0 5.36-4.19 9.72-9.336 9.72h-.004a9.042 9.042 0 0 1-4.462-1.183l-4.95 1.352Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m1.756 23.893 1.372-5.215a10.366 10.366 0 0 1-1.29-5.035c0-5.554 4.34-10.068 9.67-10.068 1.271 0 2.53.26 3.703.767a9.655 9.655 0 0 1 3.138 2.184c.898.936 1.61 2.047 2.096 3.27.486 1.222.736 2.532.735 3.855-.002 5.553-4.341 10.068-9.671 10.068h-.004a9.363 9.363 0 0 1-4.622-1.226l-5.127 1.4Zm5.365-3.222.294.18a7.79 7.79 0 0 0 4.09 1.168h.004c4.43 0 8.036-3.755 8.038-8.37 0-1.098-.207-2.187-.61-3.203a8.402 8.402 0 0 0-1.742-2.716 8.026 8.026 0 0 0-2.607-1.816 7.762 7.762 0 0 0-3.076-.639c-4.434 0-8.04 3.754-8.042 8.368A8.608 8.608 0 0 0 4.7 18.097l.192.316-.81 3.088 3.04-.83Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.092 9.434c-.182-.42-.371-.428-.544-.435-.14-.007-.302-.006-.464-.006a.86.86 0 0 0-.354.087.892.892 0 0 0-.29.228c-.222.252-.846.86-.846 2.098s.866 2.435.987 2.603c.121.168 1.672 2.79 4.127 3.799 2.04.838 2.458.671 2.9.627.441-.044 1.43-.609 1.63-1.196.203-.588.202-1.091.14-1.197-.062-.105-.222-.168-.464-.293-.242-.126-1.43-.735-1.65-.819-.223-.083-.383-.126-.545.126-.161.253-.624.819-.765.987-.141.168-.282.189-.524.063-.241-.126-1.02-.392-1.942-1.249-.72-.667-1.206-1.49-1.345-1.743-.14-.252-.015-.386.106-.513.108-.113.242-.294.363-.441.12-.147.16-.252.241-.42.08-.168.04-.315-.02-.44-.061-.127-.527-1.37-.741-1.866Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 11.469,
    x2: 11.469,
    y1: 23.542,
    y2: 3.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 11.468,
    x2: 11.468,
    y1: 23.893,
    y2: 3.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.0d3c58be329df04ae6215c30742190cb.svg";
export { ForwardRef as ReactComponent };